import { render, staticRenderFns } from "./colorsTab.vue?vue&type=template&id=06e0d5cc&scoped=true&"
import script from "./colorsTab.vue?vue&type=script&lang=js&"
export * from "./colorsTab.vue?vue&type=script&lang=js&"
import style0 from "./colorsTab.vue?vue&type=style&index=0&id=06e0d5cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e0d5cc",
  null
  
)

export default component.exports